import LoginTwoStepEmailStepPasswordForm from './form';

export default function LoginTwoStepEmailStepPassword() {
  return <LoginTwoStepEmailStepPasswordForm />;
}
